import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'

import { wizard, meta } from 'helpers/decorators'
import { Title, Note, Button, FormDebug } from 'components/misc'
import { Parent as ParentForm } from 'components/forms'
import { apiParticipants, apiConfiguration } from 'helpers/decorators/api'
import validate from './parent.validate'
import { participants } from 'constants/wizards'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { initializeFormFields } from '../../../../helpers/formInitializationHelper'
import { isStepActive } from 'helpers/wizardHelper'

const enhance = compose(
  apiParticipants(),
  apiConfiguration(),
  wizard({
    form: 'participantRegistration',
    multipage: true,
    validate,
    destroyOnUnmount: false
  }),
  meta({
    title: 'Register participant',
    intlKey: 'pageTitle.register_participant'
  }),
  connect(
    ({ api }) => ({
      registrationInfo: get(api, 'participants.registrationInfo')
    }), {}
  )
)

class Parent extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    values: PropTypes.object,
    onGetConfigurationValue: PropTypes.func.isRequired,
    configuration: PropTypes.object.isRequired,
    initialize: PropTypes.func.isRequired,
    registrationInfo: PropTypes.object,
    changeWizardNext: PropTypes.func,
    wizardSteps: PropTypes.array
  }

  componentDidMount = async() => {
    const registrationInfo = get(this.props, 'registrationInfo')

    if (registrationInfo) {
      const fieldsToInit = [
        { name: 'parentFirstName', value: get(registrationInfo, 'parentFirstName', null) },
        { name: 'parentLastName', value: get(registrationInfo, 'parentLastName', null) },
        { name: 'parentRelationship', value: get(registrationInfo, 'parentRelationship', null) },
        { name: 'parentPhone', value: get(registrationInfo, 'parentPhone', null) },
        { name: 'parentEmail', value: get(registrationInfo, 'parentEmail', null) },
        { name: 'parentEmailCheck', value: get(registrationInfo, 'parentEmail', null) },
        { name: 'consentDeliveryType.value', value: get(registrationInfo, 'consentDeliveryType.value', null) },
      ]

      initializeFormFields(this.props, fieldsToInit)
    }
  }

  handleSubmit = async fields => {
    const { rootPath, steps } = participants

    if (!isStepActive(this.props.wizardSteps, steps.profile.id) && !isStepActive(this.props.wizardSteps, steps.payment.id)) {
      await this.props.changeWizardNext(steps.parent.id, rootPath + steps.account.path)
    }

    return this.props.onSubmit(fields)
  }

  render() {
    const { handleSubmit, values } = this.props

    return (
      <form
        onSubmit={handleSubmit(this.handleSubmit)}
        data-testId="registrationParentForm"
      >
        <Title h1>
          <FormattedMessage
            id="moduleTitle.profile_guardian_consent"
            defaultMessage="Profile/Guardian Consent"
          />
        </Title>

        <Note lighter margin="0 0 35px 0">
          <FormattedMessage
            id="label.because_your_age_is_under_18"
            defaultMessage="Because your age is under 18 we need to consent from your parent/guardian."
          />
        </Note>

        <ParentForm
          values={values}
          onGetConfigurationValue={this.props.onGetConfigurationValue}
          configuration={this.props.configuration}
        />

        <FormDebug {...this.props} />
        <Button>
          <FormattedMessage id="button.continue" defaultMessage="Continue" />
        </Button>
      </form>
    )
  }
}

export default enhance(Parent)
